
import React, { useMemo, useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "./Blog.css";

export default function BlogPost({ post, onBack, navigateTo }) {
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
      return;
    }

    if (typeof navigateTo === "function") {
      navigateTo("blog-list");
    }
  };

  const galleryImages = useMemo(() => {
    if (!post) return [];

    if (Array.isArray(post.images) && post.images.length > 0) {
      return post.images.map((item, index) => {
        if (typeof item === "string") {
          return {
            src: item,
            alt: `${post.title} - تصویر ${index + 1}`,
          };
        }

        return {
          src: item.src || item.image || post.image || "/default-blog.jpg",
          alt: item.alt || `${post.title} - تصویر ${index + 1}`,
        };
      });
    }

    if (post.image) {
      return [
        {
          src: post.image,
          alt: post.title,
        },
      ];
    }

    return [];
  }, [post]);

  const getReadingTime = () => {
    if (!post) return "";

    const text = `${post.summary || ""} ${post.content || ""}`;
    const words = text.trim().split(/\s+/).filter(Boolean).length;
    const minutes = Math.max(1, Math.ceil(words / 180));

    return `${minutes} دقیقه مطالعه`;
  };

  const goToPreviousImage = () => {
    setActiveImageIndex((prev) =>
      prev === 0 ? galleryImages.length - 1 : prev - 1
    );
  };

  const goToNextImage = () => {
    setActiveImageIndex((prev) =>
      prev === galleryImages.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <>
      <Header navigateTo={navigateTo} />

      <main className="blog-post-page">
        {!post ? (
          <section className="post-not-found">
            <span>😕</span>
            <p>پست مورد نظر یافت نشد.</p>
            <button
              type="button"
              onClick={handleBack}
              className="back-to-blog-btn"
            >
              ← بازگشت به بلاگ
            </button>
          </section>
        ) : (
          <>
            <section className="blog-post-hero">
              <div className="blog-post-hero-content">
                {post.category && (
                  <span className="blog-post-category">{post.category}</span>
                )}

                <h1 className="blog-post-title">{post.title}</h1>

                <div className="blog-post-meta">
                  <span>✍️ نویسنده: {post.author || "نقش خیال"}</span>
                  <span>📅 تاریخ انتشار: {post.date}</span>
                  <span>⏱️ {getReadingTime()}</span>
                </div>
              </div>
            </section>

            <article className="blog-post-container">
              {galleryImages.length > 0 && (
                <div className="blog-post-gallery">
                  <div className="blog-post-image">
                    <img
                      src={galleryImages[activeImageIndex].src}
                      alt={galleryImages[activeImageIndex].alt}
                      onError={(e) => {
                        e.currentTarget.src = "/default-blog.jpg";
                      }}
                    />

                    {galleryImages.length > 1 && (
                      <>
                        <button
                          type="button"
                          className="gallery-nav-btn gallery-prev"
                          onClick={goToPreviousImage}
                          aria-label="تصویر قبلی"
                        >
                          ‹
                        </button>

                        <button
                          type="button"
                          className="gallery-nav-btn gallery-next"
                          onClick={goToNextImage}
                          aria-label="تصویر بعدی"
                        >
                          ›
                        </button>

                        <div className="gallery-counter">
                          {activeImageIndex + 1} / {galleryImages.length}
                        </div>
                      </>
                    )}
                  </div>

                  {galleryImages.length > 1 && (
                    <div className="gallery-thumbnails">
                      {galleryImages.map((image, index) => (
                        <button
                          type="button"
                          key={`${image.src}-${index}`}
                          className={`gallery-thumb ${
                            activeImageIndex === index ? "active" : ""
                          }`}
                          onClick={() => setActiveImageIndex(index)}
                          aria-label={`نمایش تصویر ${index + 1}`}
                        >
                          <img
                            src={image.src}
                            alt={image.alt}
                            onError={(e) => {
                              e.currentTarget.src = "/default-blog.jpg";
                            }}
                          />
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}

              <div className="blog-post-content">
                {post.content
                  ?.split("\n")
                  .filter((paragraph) => paragraph.trim())
                  .map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
              </div>

              <div className="blog-post-bottom-actions">
                <button
                  type="button"
                  onClick={handleBack}
                  className="back-to-blog-btn"
                >
                  ← بازگشت به لیست پست‌ها
                </button>
              </div>
            </article>
          </>
        )}
      </main>

      <Footer navigateTo={navigateTo} />
    </>
  );
}